import DefaultDetail from "../../../Common/DefaultDetail";
import { useParams } from "react-router-dom";
import "./style.scss";

const SortDetail = () => {
    const { secondParam } = useParams();

    let inputsNew = [
        {
            blockName: "Сортировка",
            inputs: {
                bucketCode1: {
                    label: "Выберите источник оффер",
                    type: "selectSuggest",
                    filterBy: "title,_id",
                    required: true,
                    apiUrl: "/promo/suggest_list?collection=offers&project[_id]=1&project[technicalName]=1&project[code]=1&project[title]=1",
                    dataKey: "suggest.offers_suggest",
                    optionValue: "code",
                    optionLabel: "title",
                    placeholder: "Список офферов",
                    appendTo: "self",
                },

                bucketCode: {
                    label: "Корзина с промиками",
                    type: "selectSuggest",
                    filterBy: "title,_id",
                    required: true,
                    apiUrl: "/promo/suggest_list?collection=buckets&project[_id]=1&project[code]=1&project[title]=1",
                    dataKey: "suggest.buckets_suggest",
                    optionValue: "code",
                    optionLabel: "title",
                    placeholder: "Выберите корзину",
                    appendTo: "self",
                },

                bucketCode3: {
                    label: "Выберите оффер",
                    type: "selectSuggest",
                    filterBy: "title,_id",
                    required: true,
                    apiUrl: "/promo/suggest_list?collection=buckets&project[_id]=1&project[code]=1&project[title]=1",
                    dataKey: "suggest.bickets_suggest",
                    optionValue: "code",
                    optionLabel: "title",
                    placeholder: "Список проектов",
                    appendTo: "self",
                },

                sort: { label: "Место на витрине", type: "number", required: true, placeholder: "", addClass: "full" },
            },
        },
    ];

    return (
        <div className="sort-detail">
            <DefaultDetail apiUrl={"/promo/offers/" + secondParam} dataKey={secondParam} scopes={false} inputs={inputsNew} titleList={"title"} titleRight={"офферы"} urlUpload={"offers"} page={"offers"} logging={true} />
        </div>
    );
};

export default SortDetail;
